export const API_BASE_URL = "https://api-smaib.saude.rj.gov.br";

export const KEYCLOAK_URL = "https://sso-smaib.saude.rj.gov.br";

export const KEYCLOAK_REALM = "data-sec";

export const KEYCLOAK_CLIENT_ID = "data-sec-app";

export const DASHBOARD_HELP_URL = "";

export const USER_IMPORT_TEMPLATE_URL_ =
  "/bff/api/v1/static/excel/data-portal-template-import-usuarios.xlsx";

export const DISABLED_FUNCTIONS_ = "None";

export const PAGE_TITLE = "SMAIB";

export const FAVICON_LINK = "https://sso-smaib.saude.rj.gov.br/resources/8wqzh/login/sesrj-smaib/img/favicon.ico";

export const ENABLE_NEW_USER_BTN = "";

export const ENABLE_IMPORT_USER_BTN = "false";

export const VUE_APP_SHOW_MUNICIPIOS = "true";

export const VUE_APP_SHOW_REGIOES_SAUDE = "true";

export const HOME_MESSAGE = "Secretaria de Saúde - SGVS, todos os direitos reservados.";

export const ENABLE_IFRAME_RESIZER = "";

export const LIST_EXTERNAL_APP_SHOW_HEADER =
  "";

export const LIST_EXTERNAL_APP_ENABLED_ORIGIN =
  "https://smaib-indicador.saude.rj.gov.br";

export const ENABLE_DARK_MODE = "";

export const SHOW_SEGMENTATION = "";

export const DEBUG = "";

export const USER_DEFAULT_ATTRIBUTES = "nmMunicipio,idMunicipio,idPerfil,lastLogin,priorLogin,idSegmentacao";

export const ENABLE_EXTREME_FORMS_SSO_SYNC =
  "";

export const SELECTED_HOME = "";

export const USER_ADDITIONAL_ATTRIBUTES = "Setor";

export const VUE_APP_PREVENT_DELETE_GROUPS = "ADMIN,GESTOR_TECNICO_ESTADUAL,GESTOR_ESTADUAL,GESTOR_MUNICIPAL,CONSELHO_MUNICIPAL,ANALISTA_MUNICIPAL,ANALISTA_ESTADUAL,CONSELHO_ESTADUAL";

export const DEFAULT_REALM_KEY = "";

export const CIDADAO_REALM_UNUSED_ATTRIBUTES =
  "";

export const MULTIPLE_DOMAINS = "";

export const VUE_APP_ENABLE_REGULAMENTOS = "";

export const VUE_APP_NAVBAR_TITLE = "";
